import { axiosHelper } from 'Services/AxiosHelper';
import { onOnlineApplicationQueryBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';
import { ProductPriceModel } from 'Models';

const command = 'b2c.RIProductPrice';

const productPrice = async (params: onOnlineApplicationQueryBodyData): Promise<ProductPriceModel> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default productPrice;
